import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
// components
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs';
//
import { getStudentBreadcrumbs } from './studentBreadcrumbsLinks';

// ----------------------------------------------------------------------

const StudentBreadcrumbsContext = createContext(null);

StudentBreadcrumbsProvider.propTypes = {
  children: PropTypes.node,
};

export function StudentBreadcrumbsProvider({ children }) {
  const [courseName, setCourseName] = useState('');

  const value = useMemo(() => ({ courseName, setCourseName }), [courseName]);

  return (
    <StudentBreadcrumbsContext.Provider value={value}>
      {children}
    </StudentBreadcrumbsContext.Provider>
  );
}

/**
 * Publica o nome do curso em foco para a trilha do layout.
 * Sem provider (ex.: testes isolados da página) vira no-op.
 */
export function useStudentCourseBreadcrumb(courseName) {
  const context = useContext(StudentBreadcrumbsContext);
  const setCourseName = context?.setCourseName;

  useEffect(() => {
    if (!setCourseName) return undefined;

    setCourseName(courseName || '');
    return () => setCourseName('');
  }, [courseName, setCourseName]);
}

export default function StudentBreadcrumbs() {
  const { pathname } = useLocation();
  const context = useContext(StudentBreadcrumbsContext);

  const links = useMemo(
    () => getStudentBreadcrumbs(pathname, { courseName: context?.courseName }),
    [pathname, context?.courseName]
  );

  if (!links.length) return null;

  return <CustomBreadcrumbs links={links} sx={{ mb: 3 }} aria-label="Navegação da área do aluno" />;
}
